import React from 'react';
import { motion } from 'framer-motion';
import { ClosingLine, InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { conversationApps, peerAnswers } from '../../data/snakkerStory';
export function SlideConversation({}: SlideProps) {
  return <InteriorSlide surface data-id="element-374" data-mp="24rcqzdbqu4in">
      <SlideTitle eyebrow="Congress · Symposium · F2F" data-id="element-375" data-mp="24qjst0quonc4">
        Turn communication into <span className="text-[var(--brand)]" data-id="element-376" data-mp="1qrtuxiw7ijmp">conversation.</span>
      </SlideTitle>

      <div className="mt-[clamp(1.25rem,2.5vw,2.25rem)] flex min-h-0 flex-1 gap-[clamp(1rem,2vw,2rem)]" data-id="element-377" data-mp="1vrpospb6wuoj">
        <ol className="grid min-h-0 flex-1 grid-cols-2 gap-[clamp(0.5rem,1vw,0.9rem)] lg:grid-cols-4" data-id="element-378" data-mp="1hrx00zj84oj7">
          {conversationApps.map((app, i) => <motion.li key={app.title} initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15 + i * 0.08,
          duration: 0.45
        }} className="flex min-h-0 flex-col rounded-2xl bg-white p-[clamp(1rem,1.8vw,1.6rem)] ring-1 ring-[var(--fg)]/[0.06]" data-id="element-379" data-mp="1lv3543ulo9o3" data-mpi={i}>
              <span className="self-start rounded-full bg-[var(--surface)] px-2.5 py-0.5 font-mono text-[clamp(0.56rem,0.72vw,0.68rem)] uppercase tracking-[0.18em] text-[var(--brand)]" data-id="element-380" data-mp="16u5xv1yngwc">
                {app.moment}
              </span>
              <h3 className="mt-auto pt-[clamp(1rem,2vw,2rem)] text-[clamp(1.1rem,1.8vw,1.7rem)] font-extrabold leading-[1.05] tracking-[-0.035em] text-[var(--fg)]" data-id="element-381" data-mp="awniay9xg01n">
                {app.title}
              </h3>
              <p className="mt-2 text-[clamp(0.76rem,1vw,0.95rem)] leading-snug text-[var(--muted)]" data-id="element-382" data-mp="3eeypvmq8qwap">{app.body}</p>
            </motion.li>)}
        </ol>

        <motion.aside initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5,
        duration: 0.5
      }} aria-label="Optional peer mechanic" className="hidden w-[28%] flex-shrink-0 flex-col rounded-2xl bg-[var(--fg)] p-[clamp(1rem,1.8vw,1.6rem)] text-white md:flex" data-id="element-383" data-mp="3o9z2anziayjb">
          <p className="font-mono text-[clamp(0.56rem,0.72vw,0.68rem)] uppercase tracking-[0.18em] text-[var(--brand-lighter)]" data-id="element-384" data-mp="1fmu3h9ia9psw">Optional peer mechanic</p>
          <p className="mt-[clamp(0.75rem,1.5vw,1.25rem)] text-[clamp(1.1rem,1.8vw,1.65rem)] font-extrabold leading-[1.1] tracking-[-0.03em]" data-id="element-385" data-mp="1kmginoho9g4c">
            You chose <span className="text-[var(--brand-lighter)]" data-id="element-386" data-mp="rxi04q9n0byi">No.</span>
            <br data-id="element-387" data-mp="rv58tmhzop8s" />
            What did your peers choose?
          </p>
          <ul className="mt-auto space-y-3 pt-[clamp(1rem,2vw,1.75rem)]" data-id="element-388" data-mp="wx4cyyljzq6s">
            {peerAnswers.map((a, i) => <li key={a.label} data-id="element-389" data-mp="11u4jtbq88wyy" data-mpi={i}>
                <div className="flex items-baseline justify-between text-[clamp(0.7rem,0.9vw,0.85rem)] font-semibold" data-id="element-390" data-mp="16lvz2q3xng9s">
                  <span className={a.you ? 'text-white' : 'text-white/60'} data-id="element-391" data-mp="97jro91xgguc">{a.label}</span>
                  <span className="tabular-nums" data-id="element-392" data-mp="e5bhmxj0hsvw">{a.share}%</span>
                </div>
                <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-white/10" data-id="element-393" data-mp="2rfuta02wiv5b">
                  <motion.div className={`h-full rounded-full ${a.you ? 'bg-[var(--brand-lighter)]' : 'bg-white/40'}`} initial={{
                width: 0
              }} animate={{
                width: `${a.share}%`
              }} transition={{
                delay: 0.8 + i * 0.1,
                duration: 0.7,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-394" data-mp="2nejcmk209k99" />
                </div>
              </li>)}
          </ul>
          <p className="mt-3 font-mono text-[0.6rem] tracking-[0.1em] text-white/40" data-id="element-395" data-mp="23q0g1heo74kj">Illustrative</p>
        </motion.aside>
      </div>

      <ClosingLine delay={0.8} data-id="element-396" data-mp="1zpgkgi9qw90i">
        The same content can start a conversation <span className="text-[var(--brand)]" data-id="element-397" data-mp="1uqn7qs2a8m1e">before, during and after</span> the meeting.
      </ClosingLine>
    </InteriorSlide>;
}